// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "vendor" + "." + "54025a4619a2ceb01070" + ".js";
};